import Slider from "react-slick";
import { bannerData } from "../../constant/fake-data";
import { cardData } from "../../constant/fake-data";
import Button from "../../components/Button/index";
import { IMAGES } from "../../constant/Image";

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow next" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="15"
        viewBox="0 0 9 15"
        fill="none"
      >
        <path
          d="M9 7.50009L0 0L5.72727 7.50009L0 15L9 7.50009Z"
          fill="#0B0C0C"
        />
      </svg>
    </div>
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom-arrow prev" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="15"
        viewBox="0 0 9 15"
        fill="none"
      >
        <path
          d="M0 7.49991L9 15L3.27273 7.49991L9 0L0 7.49991Z"
          fill="#0B0C0C"
        />
      </svg>
    </div>
  );
};

export default function SimpleSlider() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <Slider {...settings} className="Hero-banner-slider">
      {bannerData.map((val) => (
        <div key={val.id} className="main-slider-box">
          <div className="down-arrow-box">
            <a href="/">
              <img src={IMAGES.down_arrow} alt="" />
            </a>
          </div>
          <div className="Main-box-slider">
            <div className="img-abs">
              <img src={val.image} alt={`Slide ${val.id + 1}`} />
            </div>
            <div className="container">
              <div className="content-box">
                <div className="inline-headings">
                  <h1>{val.title1}</h1>
                  <h2 className="font-playfair">{val.title2}</h2>
                </div>
                <h3>{val.title3}</h3>
                <div className="btn-flex">
                  <Button
                    text="Start A Bid  "
                    primary={true}
                    icon={true}
                    onClick={() => console.log("Red clicked")}
                  />
                  <Button
                    text="View All Auction"
                    bgColor="white"
                    textColor="black"
                    primary={true}
                    onClick={() => console.log("White clicked")}
                    customStyle={{}}
                  />
                </div>
              </div>
            </div>
            {/* <- ye content-box wali div ka close */}
          </div>
          {/* <- ye Main-box-slider wali div ka close */}
        </div>
      ))}
    </Slider>
  );
}
